import { jsxs as l, Fragment as _, jsx as r } from "react/jsx-runtime";
import s from "react";
import u from "next/script";
import { u as S } from "../../chunks/use-is-experience-editor.DQiAVZeB.js";
import { u as m } from "../../chunks/use-sitecore-context.C7g4vcbm.js";
const d = "https://cdn-prod.securiti.ai", L = `${d}/consent/cookie-consent-sdk-loader-strict-csp.js`, C = "c2a0cde4-f9d5-4dd6-ba6d-3afc6437e4bc", g = "hca-cookie-consent-script", E = "text/javascript", I = "https://app.securiti.ai", R = `${d}/consent/auto_blocking/${C}`, h = () => {
  const {
    sitecoreContext: { cookieConsentID: o, language: e }
  } = m(), c = S(), [a, f] = s.useState(!1), [t, p] = s.useState(null), i = s.useRef(e);
  return s.useEffect(() => {
    c || a || typeof window > "u" || (window.SecuritiDataLayer = window.SecuritiDataLayer || [], window.SecuritiDataLayer.push(
      [
        "beforeLoad",
        (n) => {
          n.setLanguage(e === "es-US" ? "es" : "en");
        }
      ],
      [
        "onLoad",
        (n) => {
          p(n);
        }
      ]
    ), f(!0));
  }, [a, c, e]), s.useEffect(() => {
    var n;
    t && i.current !== e && (t.closeBanner(), (n = t.changeLanguage) == null || n.call(t, e === "es-US" ? "es" : "en"), i.current = e);
  }, [e, t]), o && a ? /* @__PURE__ */ l(_, { children: [
    /* @__PURE__ */ r(
      u,
      {
        id: g,
        defer: !0,
        src: L,
        "data-strict-csp": !0,
        "data-skip-css": !1,
        "data-tenant-uuid": C,
        "data-domain-uuid": o,
        "data-backend-url": I
      }
    ),
    /* @__PURE__ */ r(u, { type: E, src: `${R}/${o}.js` })
  ] }) : null;
};
export {
  R as CC_AUTO_BLOCKING_URL,
  I as CC_BE_URL,
  g as CC_SCRIPT_ID,
  E as CC_SCRIPT_TYPE,
  L as CC_SCRIPT_URL,
  C as CC_TENANT_ID,
  h as CookieConsent
};
